import React from 'react';
import { X, Package, Clock, CheckCircle, CreditCard } from 'lucide-react';


const ProcessRefundModel = ({  currentStepData, setProcessModal ,getDataRefundProcessSteps ,subStep}) => {
  // console.log(subStep,"subStep");
  
  // console.log(getDataRefundProcessSteps,"getDataRefundProcessSteps");
  const refundStepsRaw = [
    {
      id: 1,
      title: 'Refund Request',
      description: 'Submitted refund request with payment details for admin to review',
      status: currentStepData >= 1 ? 'completed' : 'pending',
      icon: <Package className="w-5 h-5" />
    },
    {
      id: 2,
      title: `${getDataRefundProcessSteps?.status?.status}`,
      description: 'Waiting for admin to process the refund request',
      status: currentStepData >= 2
      ? (
          getDataRefundProcessSteps?.status?.status === "reject"
            ? "rejected"
            : getDataRefundProcessSteps?.status?.status === "pending"
              ? "current"
              : getDataRefundProcessSteps?.status?.status === "approve"
                ? "completed"
                : "pending"
        )
      : "pending",
      icon: currentStepData >= 2
      ? (
          getDataRefundProcessSteps?.status?.status === "reject"
            ? <X className="w-5 h-5" />
            : <Clock className="w-5 h-5" />
        )
      : <Clock className="w-5 h-5" />,
    },
    {
      id: 3,
      title: 'Processing',
      description: 'Waiting for admin to process the refund request',
      status: currentStepData >= 3 ? (currentStepData === 3 ? 'current' : 'completed') : 'pending',
      icon: <Clock className="w-5 h-5" />
    },
    // {
    //   id: 3,
    //   title: `${getDataRefundProcessSteps?.status?.status === "reject" ? "Rejected" : "Approved"}`,
    //   description: 'Refund request has been approved and authorized by admin',
    //   status: getDataRefundProcessSteps?.status?.status === 'reject'
    //     ? 'rejected'
    //     : (currentStepData >= 3 ? (currentStepData === 3 ? 'current' : 'completed') : 'pending'),
    //   icon: <CheckCircle className="w-5 h-5" />
    // },
    {
      id: 4,
      title: 'Refund Issued',
      description: 'Refund has been issued to the original payment method as per admin\'s decision',
      status: currentStepData >= 4 ? 'completed' : (currentStepData === 4 ? 'current' : 'pending'),
      icon: <CreditCard className="w-5 h-5" />
    }
  ];

  // Only show 4th step if not rejected
  const refundSteps = getDataRefundProcessSteps?.status?.status === 'reject'
    ? refundStepsRaw.slice(0, 2)
    : refundStepsRaw;

  const getStepStyles = (status) => {
    switch (status) {
      case 'completed':
        return {
          circle: 'bg-green-500 border-green-500 text-white',
          line: 'bg-green-500',
          content: 'text-gray-900',
          description: 'text-gray-600'
        };
      case 'current':
        return {
          circle: 'bg-blue-500 border-blue-500 text-white animate-pulse',
          line: 'bg-gray-300',
          content: 'text-blue-600 font-400',
          description: 'text-gray-700'
        };
      case 'rejected':
        return {
          circle: 'bg-red-500 border-red-500 text-white',
          line: 'bg-gray-300',
          content: 'text-red-600 font-400',
          description: 'text-gray-700'
        };
      default:
        return {
          circle: 'bg-white border-gray-300 text-gray-400',
          line: 'bg-gray-300',
          content: 'text-gray-400',
          description: 'text-gray-400'
        };
    }
  };

  return (
    <>
      {/* Overlay */}
      {/* <div 
        className={`fixed inset-0 bg-white bg-opacity-50 transition-opacity duration-300 z-40 ${
          setProcessModal ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      /> */}

      {/* Sidebar */}
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
          setProcessModal ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-[#FCDD00] font-Poppins">
          <div className="my-[7px]">
            <h2 className="text-xl text-gray-900 font-500">
            Track Refund Process
            </h2>
            {/* <p className="mt-1 text-sm text-gray-600">
              Track  refund status
            </p> */}
          </div>
          <button
            onClick={() => setProcessModal(false)}
            className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Progress Steps */}
        <div className="flex-1 p-6 overflow-y-auto font-Poppins">
          <div className="relative">
            {refundSteps.map((step, index) => {
  const isProcessingStep = step.id === 3 && currentStepData === 3 ;

              const styles = getStepStyles(step.status);
              const isLast = index === refundSteps.length - 1;

              return (
                <div key={step.id} className="relative flex items-start mb-8">
                  {/* Vertical Line */}
                  {!isLast && (
                    <div className={`absolute left-6 top-12 w-0.5  ${isProcessingStep ? "h-36" : "h-[75px]"} bg-gray-200`}>
                      <div
                        className={`w-full h-full transition-all duration-500 ${
                          step.status === "completed"
                            ? "bg-green-500"
                            : "bg-gray-300"
                        }`}
                      />
                    </div>
                  )}

                  {/* Step Circle */}
                  <div
                    className={`relative flex-shrink-0 w-12 h-12 border-2 rounded-full flex items-center justify-center transition-all duration-300 ${styles.circle}`}
                  >
                    {step.status === "completed" ? (
                      <CheckCircle className="w-6 h-6" />
                    ) : (
                      step.icon
                    )}

                    {/* Pulse animation for current step */}
                    {step.status === "current" && (
                      <div className="absolute inset-0 border-2 border-blue-400 rounded-full animate-ping" />
                    )}

                  </div>

                  {/* Step Content */}
                  <div className="flex-1 min-w-0 ml-4">
                    {/* Sub-steps for Processing */}
                   
                    <h3
                      className={`text-sm font-medium transition-colors duration-300 capitalize ${styles.content} `}
                    >
                      {step.title}
                    </h3>
                    <p
                      className={`text-xs mt-1 transition-colors duration-300 ${styles.description}`}
                    >
                      {step.description}
                    </p>

                    {/* Status badge for current step */}
                    {step.status === "current" && (
                      <div className="mt-2">
                        <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded-full">
                          In Progress
                        </span>
                      </div>
                    )}

                    {/* Completion time for completed steps */}
                    {step.status === "completed" && (
                      <div className="mt-2">
                        <span className="text-xs font-medium text-green-600">
                          ✓ Completed
                        </span>
                      </div>
                    )}
                     {isProcessingStep && (
                      <div className="mt-4 ml-2">
                        <div className="flex flex-col gap-2 pl-4 border-l-2 border-gray-200">
                          <div className="flex items-center gap-2">
                            <span className={`w-3 h-3 rounded-full ${subStep >0 ? 'bg-blue-400' : 'bg-gray-300'} inline-block `}></span>
                            <span className="text-xs text-gray-700">Initiate Refund</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className={`w-3 h-3 rounded-full ${subStep >1 ? 'bg-blue-400' : 'bg-gray-300'} inline-block `}></span>
                            <span className="text-xs text-gray-700">Bank Processing</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className={`w-3 h-3 rounded-full ${subStep >2 ? 'bg-blue-400' : 'bg-gray-300'} inline-block `}></span>
                            <span className="text-xs text-gray-700">Confirmation Received</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Progress Summary */}
          <div className="mt-8 p-4 bg-[#fff7bbc9] rounded-lg  border border-[#FCDD00]">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-black">
                Overall Progress
              </span>
              <span className="text-sm font-bold text-black">
                {Math.round((currentStepData / refundSteps.length) * 100)}%
              </span>
            </div>
            <div className="w-full h-2 bg-gray-300 rounded-full">
              <div
                className="bg-gradient-to-r from-[#FCDD00] to-[#FCDD00]/80 h-2 rounded-full transition-all duration-500 ease-out"
                style={{
                  width: `${(currentStepData / refundSteps.length) * 100}%`,
                }}
              />
            </div>
          </div>

          {currentStepData === 3 && (
            <div className="mt-4 p-4 bg-[#fff7bbc9] rounded-lg border border-[#FCDD00]">
              <h4 className="mb-1 text-sm font-semibold text-black">
                Estimated Time
              </h4>
              <p className="text-xs text-black">
                Refund processing typically takes 5-7 business days from
                approval
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProcessRefundModel;